import React from 'react';
import { useNavigate } from 'react-router-dom';

export const SkusHealthMenu = () => {

    const navigate = useNavigate();

    return (
        <div>
            <button className='btn btn-square btn-tertiary-outline' onClick={() => { navigate('integrity') }}>Integrity</button>
            <button className='btn btn-square btn-tertiary-outline' onClick={() => { navigate('feature-offset') }}>Feature Offsets</button>
            <button className='btn btn-square btn-tertiary-outline' onClick={() => { navigate('stale-pending-transmission') }}>Stale Status Skus</button>
            <button className='btn btn-square btn-tertiary-outline' onClick={() => { navigate('file-count-issues') }}>File Count Issues</button>
        </div>
    )
}